<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                            <router-link :to="{'name': 'CadastrarEmpresas'}" class="button big block-mobile float-right hidden-md hidden-lg">
                                <i class="material-icons">add</i>
                                Cadastrar filial
                            </router-link>
                        </h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row">
                        <!-- Dashboard Box -->
                        <div class="col-lg-12 margin-bottom-20 hidden-xl">
                            <router-link :to="{'name': 'CadastrarEmpresas'}" class="button big block-mobile">
                                <i class="material-icons">add</i>
                                Cadastrar filial
                            </router-link>
                        </div>                        
                        <div class="col-xl-12">
                            <form method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="get">
                                <div class="row">
                                    <div class="col-lg-7 col-xs-12 col-xl-6 col-md-7">
                                        <div class="submit-field">
                                            <h5>Pesquisar filial:</h5>
                                            <input type="text" class="with-border margin-bottom-0" placeholder="Nome, e-mail, telefone ou CNPJ.." name="pesquisa" v-model="form.pesquisa">
                                        </div>
                                    </div>

                                    <div class="col-lg-3 col-md-4">
                                        <div class="submit-field">
                                            <div class="hidden-xl hidden-lg hidden-sm margin-top-10"></div>
                                            <div class="hidden-xs clearfix" style="margin-top: 32px;"></div>
                                            <button class="button gray " type="submit">
                                                <i class="material-icons">search</i>
                                            </button>                                         
                                        </div>
                                    </div>
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form> 

                            <div v-show="data.itens.length == 0 && loaded" class="job-overview empty">
                                <div class="job-overview-inner">
                                    <center>
                                        <i class="material-icons big">mood_bad</i>
                                        <p>Nenhum resultado encontrado.</p>
                                    </center>
                                </div>      
                            </div>

                            <div class="table-scroll" style="overflow-x: scroll;" v-show="data.itens.length > 0">

                                <table class="table table-bordered table-bordered-default table-responsive">
                                    <thead>
                                        <th style="min-width: 50px; width: 50px;">
                                            ID
                                        </th>
                                        <th style="min-width: 200px;">
                                            Nome
                                        </th>
                                        <th width="20%" style="min-width: 200px; width: 200px;">
                                            E-mail
                                        </th>
                                        <th style="min-width: 112px">
                                            Telefone
                                        </th>
                                        <th>
                                            CNPJ
                                        </th>                                                                                                       
                                        <th>
                                            Cadastro
                                        </th>         
                                        <th style="min-width: 135px; width: 135px;">
                                            Ações
                                        </th>                                                                      
                                    </thead>
                                    <tbody> 

                                        <tr v-for="item in data.itens">
                                            <td data-label="ID">
                                                <router-link :to="{'name': 'EditarEmpresas', 'query': {'c': item.cod}}">
                                                    {{item.id}}
                                                </router-link>
                                            </td>
                                            <td data-label="Nome">
                                                <router-link :to="{'name': 'EditarEmpresas', 'query': {'c': item.cod}}">
                                                    <u>{{item.nome}}</u>
                                                </router-link>
                                            </td>
                                            <td data-label="E-mail">
                                                <router-link :to="{'name': 'EditarEmpresas', 'query': {'c': item.cod}}">
                                                    {{item.email}}
                                                </router-link>
                                            </td>                   
                                            <td data-label="Telefone">
                                                <router-link :to="{'name': 'EditarEmpresas', 'query': {'c': item.cod}}">
                                                    {{item.telefone}}
                                                </router-link>
                                            </td>                      
                                            <td data-label="CNPJ">
                                                <router-link :to="{'name': 'EditarEmpresas', 'query': {'c': item.cod}}">
                                                    {{item.doc}}
                                                </router-link>
                                            </td>                                           
                                            <td data-label="Cadastro">
                                                <router-link :to="{'name': 'EditarEmpresas', 'query': {'c': item.cod}}">
                                                    {{item.datahora | formatDate}}
                                                </router-link>
                                            </td>
                                            <td data-label="Ações">
                                                <router-link :to="{'name': 'EditarEmpresas', 'query': {'c': item.cod}}" class="dashboard-status-button gray">Editar</router-link>
                                                <a class="dashboard-status-button color-red" v-on:click="del(item.cod)">Apagar</a>                                                                                      
                                            </td>                                                                                                                                         
                                        </tr>
                                       
<!--                                         <tr>
                                            <td data-label="ID">
                                                <a >
                                                    129
                                                </a>
                                            </td>
                                            <td data-label="Nome">
                                                <a >
                                                    <u>Empresa de exemplo</u>
                                                </a>
                                            </td>
                                            <td data-label="E-mail">
                                                <a >
                                                    email@exemplo.com.br
                                                </a>
                                            </td>                   
                                            <td data-label="Telefone">
                                                <a >
                                                    47999999999
                                                </a>
                                            </td>                      
                                            <td data-label="CNPJ">
                                                <a >
                                                    31777413000100
                                                </a>
                                            </td>                                           
                                            <td data-label="Cadastro">
                                                <a >
                                                    07/07/2020 12:52
                                                </a>
                                            </td>                                                                                             
                                        </tr> -->
                                    </tbody>
                                </table>
                            </div>
                        </div>                    
                    </div>

                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Empresas',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + " " + time;
        }   
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "pesquisa":         ""
            }              
        }
    },
    methods: {
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                axios.get("api/empresas.php", {params: self.form, db: "empresas"})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    self.loaded = true;
                    loading.hide();
                    resolve(response.data.result);
                    self.$root.scrollTop();
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                self.loading.del        = true;
                loading.show();
                
                axios.delete("api/empresas.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.loading.del    = false;
                    self.get();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    self.loading.del    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        }        
    },
    created: function() {
        var self = this;
        if (!self.$root.db) {
            self.$root.$on("initDB", function(data) {
                self.get();
            });
        } else {
            self.get();
        }        
    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Empresas.vue